import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FilterTransactionsPage } from './filter-transactions.page';

const routes: Routes = [
  {
    path: '',
    component: FilterTransactionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FilterTransactionsPageRoutingModule {}
